import React from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

// Dashboard
import { useGetTimesheetProfitabilitySummaryQuery } from "../../../services/Reports";
import {
  getTimesheetProfitabilitySummaryRequest,
  getTimesheetProfitabilitySummaryFailure,
  getTimesheetProfitabilitySummarySuccess,
} from "../../../store/slices/reportsSlice";

const Content = () => {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((state) => state.common.accessToken);
  const userID = useAppSelector((state) => state.common.userID);
  const profileData = useAppSelector((state) => state.settings.profileData);

  // State
  const state = useAppSelector((state) => state.reports);

  // **************
  // **************
  // Get Dashboard Data
  // **************
  // **************
  const {
    data: allTimesheetProfitabilitySummary,
    isLoading: timesheetProfitabilitySummaryLoading,
    isError: timesheetProfitabilitySummaryError,
  } = useGetTimesheetProfitabilitySummaryQuery({
    accessToken: accessToken || "",
    userID: userID || "",
    permission: true,
    pageNo: state.timesheetProfitabilitySummaryPageNo,
    pageSize: state.timesheetProfitabilitySummaryPageSize,
    fromDate: new Date(
      state.timesheetProfitabilitySummaryFromDate,
    ).toLocaleDateString(),
    toDate: new Date(
      state.timesheetProfitabilitySummaryToDate,
    ).toLocaleDateString(),
    projectId: state.projectId,
  });
  React.useEffect(() => {
    if (!accessToken && !userID) {
      return;
    }
    if (!profileData) {
      return;
    }
    if (timesheetProfitabilitySummaryLoading) {
      dispatch(getTimesheetProfitabilitySummaryRequest());
    }
    if (timesheetProfitabilitySummaryError) {
      dispatch(
        getTimesheetProfitabilitySummaryFailure(
          timesheetProfitabilitySummaryError,
        ),
      );
    }
    if (allTimesheetProfitabilitySummary) {
      dispatch(
        getTimesheetProfitabilitySummarySuccess({
          data:
            allTimesheetProfitabilitySummary.data
              .timesheetProfitabilitySummary[0].data || [],
          totalPages:
            allTimesheetProfitabilitySummary.data
              .timesheetProfitabilitySummary[0].metaData[0]?.total || 0,
        }),
      );
    }
  }, [
    accessToken,
    userID,
    allTimesheetProfitabilitySummary,
    profileData,
    state.timesheetProfitabilitySummaryFromDate,
    state.timesheetProfitabilitySummaryToDate,
    state.timesheetProfitabilitySummaryPageNo,
    state.timesheetProfitabilitySummaryPageSize,
  ]);
  return <></>;
};
export default Content;
